export const selectFileClaimWithoutJob = (state) => Number(state?.Login?.fileClaimWithoutJob);
export const selectPostDispatchCreate = (state) => Number(state?.Login?.isPsp);
export const selectSelfServicingDealer = (state) => Number(state?.Login?.isSelfServicingDealer);
